import { render, staticRenderFns } from "./LicenseList.vue?vue&type=template&id=457c5a20&scoped=true&"
import script from "./LicenseList.vue?vue&type=script&lang=ts&"
export * from "./LicenseList.vue?vue&type=script&lang=ts&"
import style0 from "./LicenseList.vue?vue&type=style&index=0&id=457c5a20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457c5a20",
  null
  
)

export default component.exports